import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Injector,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject
} from "@angular/core";
import { Resource } from "@lagoshny/ngx-hateoas-client";
import { ChildEntityDisplay } from "@app/view/shared/child-entity-display-resolver/child-entity-display";

@Directive({ selector: "[appChildEntityDisplayHost]" })
export class ChildEntityDisplayDirective {
  viewContainerRef = inject(ViewContainerRef);
}

@Component({
  selector: "app-child-entity-display-resolver",
  templateUrl: "./child-entity-display-resolver.component.html",
  styleUrls: ["./child-entity-display-resolver.component.css"],
  imports: [ChildEntityDisplayDirective]
})
export class ChildEntityDisplayResolverComponent implements OnInit {
  private componentFactoryResolver = inject(ComponentFactoryResolver);
  private injector = inject(Injector);

  @ViewChild(ChildEntityDisplayDirective, { static: true })
  appChildEntityDisplayHost: ChildEntityDisplayDirective;

  protected _resource: Resource;

  @Input()
  set resource(resource: Resource) {
    this._resource = resource;
  }

  protected _displayField: string;

  @Input()
  set displayField(displayField: string) {
    this._displayField = displayField;
  }

  protected _childType: new () => Resource;

  @Input()
  set childType(childType: new () => Resource) {
    this._childType = childType;
  }

  protected _relation: string;

  @Input()
  set relation(relation: string) {
    this._relation = relation;
  }

  protected _displayComponentType: any;

  @Input()
  set displayComponentType(displayComponentType) {
    this._displayComponentType = displayComponentType;
  }

  ngOnInit() {
    this.componentFactoryResolver
      .resolveComponentFactory(this._displayComponentType)
      .create(this.injector);
    // console.log("component ref");
    // console.log(componentRef);

    const displayComponentRef: ComponentRef<ChildEntityDisplay> =
      this.appChildEntityDisplayHost.viewContainerRef.createComponent(
        this._displayComponentType
      );
    if (!displayComponentRef) return;
    displayComponentRef.instance.resource = this._resource;
    displayComponentRef.instance.relation = this._relation;
    displayComponentRef.instance.childType = this._childType;
    displayComponentRef.instance.displayField = this._displayField;
  }
}
